import {DropdownOption} from '../models/ui/dropdownOption';

export const TIMEFRAME_OPTIONS:DropdownOption[] = [
    { value: "day", label: "energy_tool.bar_chart.day" },
    { value: "week", label: "energy_tool.bar_chart.week" },
    { value: "month", label: "energy_tool.bar_chart.month" },
    { value: "year", label: "energy_tool.bar_chart.year" },
  ]